































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'
import ModalDeleteAll from '@/app/ui/components/ModalDeleteAll/index.vue'
import { FAQModule } from '@/app/store/modules/faq'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
@Component({
  components: {
    search: Search,
    'modal-delete-all': ModalDeleteAll,
  },
})
export default class extends Vue {
  @Prop({}) public selected
  @Prop({}) public funcSearch
  @Prop({}) public isDisabled
  @Prop({}) public clearRowSelected

  public textSearch = ''
  public resetText(item) {
    //  console.log('reset search', item)
    this.textSearch = item
    this.funcSearch()
  }
  public $v: Vuelidate
  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public question: string = ''

  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public answer: string = ''
  private postData: any = {
    question: '',
    isActive: true,
    answer: '',
  }
  private optionsIsActive = [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false },
  ]
  private text: string = ''

  public resetModal() {
    this.$v.question.$reset()
    this.$v.answer.$reset()
    this.question = ''
    this.postData.isActive = true
    this.answer = ''
    this.stateActive = false
  }

  public get stateQuestion(): boolean {
    return this.postData.question.length >= 4 ? true : false
  }
  public get stateAnswer(): boolean {
    return this.postData.answer.length >= 4 ? true : false
  }
  public stateActive = false
  public postFAQ(item, index, button) {
    this.$v.question.$touch()
    this.$v.answer.$touch()
    if (this.$v.question.$invalid || this.$v.answer.$invalid) {
      this.stateActive = true
    } else {
      const dataToPost = {
        question: this.question,
        answer: this.answer,
        isActive: this.postData.isActive,
      }
      FAQModule.postFAQ(dataToPost)
      this.$root.$emit('bv::hide::modal', index, button)
    }
  }

  public modalDelete = {
    id: 'modal-deletes',
  }
  public funcDelete(item, index, button) {
    this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
  }
  // delete data
  public funcOke(item, index, button) {
    const ids = this.selected.map((i) => i.id)
    FAQModule.deleteFAQ({ ids })
    this.$root.$emit('bv::hide::modal', this.modalDelete.id, button)
    this.clearRowSelected()
  }
}
